import Component from 'gia/Component'
import _each from 'lodash.foreach'
import stage from '../components/stage'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);


class Clients extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.index = 0


    this.ref = {
      clients: ''     
    }

  }

  mount() {

    this.resizeQue = this.resize.bind(this)
    stage.on("stage:resize", this.resizeQue);
    this.resize(stage);

    

    
}


resize(e) {
 
  this.element.style.height = `${this.ref.clients.offsetHeight}px`
  //this.render(e)

}



  unmount() {




  }


}

module.exports = Clients
